module.exports = __webpack_public_path__ + "img/mastercard.a2741452.svg";